export function syncAppViewportHeight() {
  if (typeof window === "undefined") return;
  const height = Math.max(window.visualViewport?.height || 0, window.innerHeight || 0);
  if (!Number.isFinite(height) || height <= 0) return;
  document.documentElement.style.setProperty("--app-height", `${Math.max(320, Math.round(height))}px`);
}

export function resetAppViewportPosition() {
  if (typeof window === "undefined") return;
  window.scrollTo(0, 0);
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
}
